import { render } from "./mass-locks-popup.vue?vue&type=template&id=05757b3c"
import script from "./mass-locks-popup.vue?vue&type=script&setup=true&lang=js"
export * from "./mass-locks-popup.vue?vue&type=script&setup=true&lang=js"

import "./mass-locks-popup.vue?vue&type=style&index=0&id=05757b3c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/administration/users/mass-locks-popup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05757b3c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05757b3c', __exports__)) {
    api.reload('05757b3c', __exports__)
  }
  
  module.hot.accept("./mass-locks-popup.vue?vue&type=template&id=05757b3c", () => {
    api.rerender('05757b3c', render)
  })

}


export default __exports__